/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useState } from 'react'
import { VIDEOS, KIND_COLORS } from '../data/videos.js'
import { PlayIcon } from './icons.jsx'

const LIBRARY = '/sequoia-library/'

function VideoGrid() {
  const [n, setN] = useState(0)
  useEffect(() => {
    if (!VIDEOS.some((v) => v.kinds.length > 1)) return undefined
    const id = setInterval(() => setN((x) => x + 1), 3600)
    return () => clearInterval(id)
  }, [])
  return (
    <div className="seq-vl-grid" id="seq-vl-grid">
      {VIDEOS.map((v, i) => {
        const multi = v.kinds.length > 1
        const kind = multi ? v.kinds[n % v.kinds.length] : v.kinds[0]
        return (
          <a className="seq-vl-card" href={LIBRARY} key={i}>
            <div className="seq-vl-thumb">
              <img className="seq-vl-poster" loading="lazy" decoding="async" src={v.src} alt="" />
              <span className="seq-vl-shade"></span>
              <span
                key={multi ? n : 0}
                className={'seq-vl-kind' + (multi && n > 0 ? ' is-cycle' : '')}
                data-kinds={v.kinds.join('|')}
                style={{ background: KIND_COLORS[kind] || '#c4b5fd' }}
              >
                {kind}
              </span>
              <span className="seq-vl-play">
                <PlayIcon />
              </span>
            </div>
            <div className="seq-vl-overlay">
              <div className="seq-vl-tags">
                {v.tags.map((t) => (
                  <span key={t}>{t}</span>
                ))}
              </div>
              <h3 className="seq-vl-name">{v.name}</h3>
              <div className="seq-vl-chips">
                {v.chips.map((c) => (
                  <span className="seq-vl-chip" key={c}>
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </a>
        )
      })}
    </div>
  )
}

export default function VideoSection() {
  return (
    <div className="lp-videos" id="seq-videos">
      <VideoGrid />
      <div className="lp-videos-all">
        <div className="lp-videos-all-c">
          <div className="lp-videos-all-w">
            <a className="lp-videos-all-a" href={LIBRARY}>
              <span className="lp-videos-all-s">
                <span className="lp-videos-all-t">مشاهده‌ی همه</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
